// extracted by mini-css-extract-plugin
module.exports = {"image":"home-features_image__jH5kF"};